
import { useFadeIn } from '../../../hooks/useFadeIn';

export default function FinalMessage() {
  const content = useFadeIn({ direction: 'up' });
  const buttons = useFadeIn({ direction: 'up', delay: 300 });

  return (
    <section id="floating-cta-hide" className="py-32 md:py-40 px-6 bg-white">
      <div className="max-w-3xl mx-auto text-center">
        <div ref={content.ref} style={content.style}>
          <p className="text-xl md:text-2xl font-light text-gray-900 leading-relaxed tracking-wide" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            すぐ決めなくて、大丈夫です。<br />
            判断できる「診断結果」を持ち帰ってください。
          </p>
        </div>
        
        <div ref={buttons.ref} style={buttons.style} className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://reservation.stransa.co.jp/8878b04a60c23f1ce5b3268e265263cb"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-8 py-4 bg-[#3E5F8F] text-white text-base font-medium rounded-full hover:bg-[#334f77] transition-colors whitespace-nowrap cursor-pointer"
          >
            WEB予約
          </a>
          <a
            href="tel:05018094594"
            className="w-full sm:w-auto px-8 py-4 bg-white text-[#3E5F8F] text-base font-medium rounded-full border-2 border-[#3E5F8F] hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            電話で問合せ
          </a>
        </div>
      </div>
    </section>
  );
}
